// extracted by mini-css-extract-plugin
export default {"root":"SubscriptionInfoModal__root--1VdYf"};